module.exports = __webpack_public_path__ + "static/media/trophy.122ad18f.png";